export const getProductIds = (): string[] => {
  const search: string = location.search.slice(1);

  if (!search) {
    return [];
  }

  const searchParts: string[] = search.split('&');
  const productIdsSearchPart: string = searchParts
    .filter((x: string): boolean => x.toLocaleLowerCase().indexOf('productids=') === 0)[0];
  if (!productIdsSearchPart) {
    return [];
  }

  const productIds: string[] = productIdsSearchPart.split('=')[1].split(',').filter(Boolean);

  return productIds.slice(0, 3);
};
